import { render } from "./ShowMoreButton.vue?vue&type=template&id=5cefcf10&scoped=true"
import script from "./ShowMoreButton.vue?vue&type=script&lang=js"
export * from "./ShowMoreButton.vue?vue&type=script&lang=js"

import "./ShowMoreButton.vue?vue&type=style&index=0&id=5cefcf10&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cefcf10"]])

export default __exports__